import React from 'react';

export default function MapMarkerIcon(props) {
  const fillColor = props.fillColor || '#9b9b9b';
  return (
    <svg width="39px" height="49px" viewBox="0 0 39 49" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>5</title>
      <desc>Created with Sketch.</desc>
      <defs>
        <path d="M19.0338316,0 C7.92742039,0 0,7.63623 0,17.6693878 C0,32.6001029 17.0983577,46.3453169 17.8442172,47.1183673 C17.9921355,47.0618027 18.205865,47.1183673 19.0338316,47.1183673 C18.6721838,47.1183673 18.9053432,47.0429478 19.0338316,47.1183673 C19.799121,46.2321876 36.8780488,31.1105667 36.8780488,17.6693878 C36.8780488,7.63623 28.9506284,0 19.0338316,0 Z M19.0338316,27.0930612 C13.5219512,27.0930612 9.51691581,23.1272653 9.51691581,18.8473469 C9.51691581,13.3894694 13.5219512,9.42367347 19.0338316,9.42367347 C23.3560976,9.42367347 27.361133,13.3894694 27.361133,18.8473469 C27.361133,23.1272653 23.3560976,27.0930612 19.0338316,27.0930612 Z" id="path-1"></path>
      </defs>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Element/Map/Mobile/Pin" transform="translate(1.000000, 1.000000)">
          <g id="Group-2">
            <g id="5">
              <ellipse id="Oval" fill="#FFFFFF" fillRule="nonzero" cx="18.8292683" cy="18.4834246" rx="10.8292683" ry="10.6303634"></ellipse>
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <use id="Mask" stroke="#FFFFFF" fill={fillColor} fillRule="nonzero" xlinkHref="#path-1"></use>
              <g id="Color/ColorLibrary/Pending" mask="url(#mask-2)" fill={fillColor}>
                <g transform="translate(-7.400000, -4.530612)" id="Rectangle-Copy-10">
                  <rect x="0" y="0" width="55" height="54"></rect>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/Iconoclast/MapMarkerIcon/index.js